import { CURRENT_CLIENT } from '@/constants'

export function isProfilePdfEnabled(): boolean {
  return (
    (CURRENT_CLIENT as { features?: { profilePdf?: { enabled?: boolean } } }).features?.profilePdf
      ?.enabled === true
  )
}
